export default __webpack_public_path__ + "static/media/victory.7f980d92.gif";